import styled from "styled-components";
import { getHexOpacity } from "../../../../../../utils/pipes";

export const ChatbotPatientCase = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .chatbot-container {
    flex: 1;
    min-height: 300px;
    &__empty {
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    &__empty-container {
      width: 180px;
      position: relative;
      display: flex;
      justify-content: center;
      &__shadow {
        z-index: 1;
        display: flex;
        /* width: 10px;
          height: 10px; */
        position: absolute;
        align-self: center;
        box-shadow: 0px 3.03px 121.47px 60px #3e76fa66;
      }
    }
    &__empty-image {
      width: 180px;
      height: 100%;
      z-index: 2;
    }
    &__empty-msg {
      margin-top: 20px;
      font-size: 17px;
      color: #707582;
    }
  }

  .chatbot-footer {
    padding: 20px;
  }

  .patient-selected-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin-top: 20px;
    .patient-selected {
      width: 100%;
      background-color: #f0f0ff;
      display: flex;
      height: auto;
      border-radius: 14px;
      padding: 10px;
      box-sizing: border-box;
      align-items: center;
      text-align: center;
      justify-content: center;
      cursor: pointer;
      margin-right: 10px;
      height: 40px;
      &__box-image {
        display: flex;
        margin-right: 10px;
        overflow: hidden;
        img {
          width: 17px;
          border-radius: 50%;
          height: 17px;
        }
      }
      &__name {
        color: #16158a;
        text-align: center;
        font-family: "Nunito Sans Bold";
        font-size: 14px;
      }
      &__icon-close {
        font-size: 10px;
        color: #16158a;
        margin-left: 13px;
      }
      &__icon-update {
        font-size: 17px;
        color: #16158a;
        margin-left: 5px;
      }
    }
    .patiet-selected__update-guide {
      display: flex;
      padding: 10px;
      justify-content: center;
      align-items: center;
      font-family: "Nunito Sans";
      font-size: 14px;
      background: rgba(109, 109, 185, 0.12);
      cursor: pointer;
      background-color: #f0f0ff;
      border-radius: 14px;
      color: #16158a;
      white-space: nowrap;
      height: 40px;
      box-sizing: border-box;
    }
  }
`;

export const ModalResponseReaction = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  height: 100%;
  width: 100%;
  .modal-background {
    background-color: ${`#090949${getHexOpacity(0.5)}`};
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 100;
  }
  .modal-container {
    z-index: 200;
    background-color: var(--white);
    width: 700px;
    margin: auto;
    box-sizing: border-box;
    max-height: 80%;
    border-radius: 14px;
    padding: 40px;
  }
`;
